module.exports = "input: '${2}'\nblank: '${3: }'\nstart state: ${4:start}\ntable:\n  ${4}:\n    ${5}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/examples/_template.yaml
// module id = 23
// module chunks = 1